import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';

export const UsersListStatus = () => {
  return (
    <TableRow>
      <TableCell
        colSpan={7}
        sx={{
          borderBottom: 'none',
          backgroundColor: '#F9F9FA',
        }}
      >
        <Box
          sx={{
            height: 'calc(100vh - 450px)',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <Stack alignItems="center" spacing={2}>
            <Stack alignItems="center">
              <Typography fontSize={13} color="#202227">
                No Users Found.
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </TableCell>
    </TableRow>
  );
};
